import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import { Text } from '@10d/tend-ui-typography';
import { Root } from './styled.js';

const Card = ({ hovered, disabled, selected, before, children, onClick, }) => {
    const theme = useTheme();
    return (React.createElement(Root, { theme: theme, "$disabled": disabled, "$selected": selected, "$hovered": hovered, onClick: onClick },
        before,
        React.createElement(Text, { disabled: disabled, style: { display: 'block', whiteSpace: 'nowrap' } }, children)));
};

export { Card };
